import { getStore } from "../store/store";

export default function getIsCopilotThemeDynamic(): boolean {
    return getStore().options.isSelected && getStore().options.refreshRate !== "None";
}
